import service from "@irati/utils/tracking/index"
import {FeedItemType} from "@irati/recognition/enums"
import {RewardOrderCost, User, Basket, Reward} from "@irati/types"

class RewardTracking {
  rewardsTabHome = () => {
    service.trackRewardEvent("recognition_view_reward_homepage")
  }

  rewardsTabViewAllRewards = () => {
    service.trackRewardEvent("recognition_reward_viewall")
  }

  rewardsTabViewRewardDetails = (reward: Reward) => {
    service.trackRewardEvent("recognition_view_reward_detail", {
      recognition_reward_name: reward.header
    })
  }

  rewardsTabAddRewardStart = (reward: Reward) => {
    service.trackRewardEvent("recognition_start_create_reward", {
      recognition_reward_attached: reward.header
    })
  }

  rewardsTabAddRewardAddRecipient = (recipients: User[]) => {
    service.trackRewardEvent("recognition_add_recipient", {
      recognition_add_recipients: recipients.length
    })
  }

  rewardsTabAddRewardAddMessage = () => {
    service.trackRewardEvent("recognition_add_message")
  }

  rewardsTabAddRewardAddCompanyValues = (basket: Basket) => {
    service.trackRewardEvent("recognition_add_company_values", {
      recognition_add_companyValues: basket.companyValues.length
    })
  }

  rewardsTabAddRewardSuccess = (recipientsCount: number, rewardTotal: RewardOrderCost, rewardHeader: string) => {
    service.trackRewardEvent("recognition_reward_send", {
      recognition_audience: recipientsCount,
      recognition_reward_attached: rewardHeader,
      recognition_reward_total: rewardTotal
    })
  }

  rewardsTabViewCustomRewardDetails = () => {
    service.trackRewardEvent("recognition_customreward_view")
  }

  rewardsTabAddCustomRewardStart = () => {
    service.trackRewardEvent("recognition_customreward_add")
  }

  rewardsTabAddCustomRewardSuccess = (basket: Basket) => {
    service.trackRewardEvent("recognition_customereward_send", {
      recognition_add_customReward: basket.custom
    })
  }

  recognitionTabFeedItemAddRewardStart = (type: FeedItemType) => {
    service.trackRewardEvent("recognition_start_addreward", {
      recognition_feedItem_type: type
    })
  }

  recognitionTabFeedItemAddRewardSuccess = (basket: Basket, reward: Reward, type: FeedItemType) => {
    service.trackRewardEvent("recognition_create_reward", {
      recognition_reward_attached: reward.header,
      recognition_reward_total: basket.costTotal,
      recognition_feedItem_type: type
    })
  }

  rewardsTabStartSendCredit = () => {
    service.trackRewardEvent("recognition_reward_start_send_credit")
  }

  rewardsTabAddCredit = () => {
    service.trackRewardEvent("recognition_reward_add_credit")
  }

  rewardsTabAddRecipient = () => {
    service.trackRewardEvent("recognition_reward_add_recipient")
  }

  rewardsTabCreditSend = () => {
    service.trackRewardEvent("recognition_reward_credit_send")
  }
}

const tracking = new RewardTracking()

export default tracking
